// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════
   Language Switcher — Dropdown
   ════════════════════════════════════════════════════ */
.lang-switcher {
  position: relative;
  display: inline-block;
}

.lang-switcher__trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  padding: 5px 10px 5px 12px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #111;
  letter-spacing: 0.03em;
  transition: border-color 0.18s, background 0.18s;
  white-space: nowrap;
}

.lang-switcher__trigger:hover {
  border-color: #111;
  background: #f5f5f5;
}

.lang-switcher__flag {
  font-size: 16px;
  line-height: 1;
}

.lang-switcher__label {
  font-size: 13px;
  font-weight: 600;
}

.lang-switcher__chevron {
  width: 14px;
  height: 14px;
  color: #666;
  transition: transform 0.2s;
  flex-shrink: 0;
}

.lang-switcher--open .lang-switcher__chevron {
  transform: rotate(180deg);
}

/* Dropdown panel */
.lang-switcher__dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: #fff;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  min-width: 130px;
  z-index: 999;
  animation: dropdown-in 0.15s ease;
}

[dir="rtl"] .lang-switcher__dropdown {
  right: auto;
  left: 0;
}

@keyframes dropdown-in {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.lang-switcher__option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #333;
  text-align: left;
  transition: background 0.15s;
}

.lang-switcher__option:hover {
  background: #f5f5f5;
}

.lang-switcher__option--active {
  font-weight: 700;
  color: #111;
  background: #f9f9f9;
}

.lang-switcher__option--active::after {
  content: "✓";
  margin-left: auto;
  font-size: 12px;
  color: #111;
}

[dir="rtl"] .lang-switcher__option {
  text-align: right;
  flex-direction: row-reverse;
}

[dir="rtl"] .lang-switcher__option--active::after {
  margin-left: 0;
  margin-right: auto;
}

/* ── Mobile: group lang + hamburger together ── */
.rassd-nav__right-mobile {
  display: none;
  align-items: center;
  gap: 10px;
}

@media (max-width: 768px) {
  .rassd-nav__links {
    display: none !important;
  }
  .rassd-nav__right-mobile {
    display: flex;
  }
}


.rassd-root--ar,
.rassd-root--ar * {
  font-family: "Segoe UI", "Tahoma", "Arial", sans-serif;
}
[dir="rtl"] .rassd-nav__mobile-link{ text-align: right; }
[dir="rtl"] .rassd-feature-card { text-align: right; }
[dir="rtl"] .form-group { text-align: right; }
[dir="rtl"] .form-input,
[dir="rtl"] .form-textarea { text-align: right; }
[dir="rtl"] .rassd-nav__mobile-menu { text-align: right; }
`, "",{"version":3,"sources":["webpack://./src/lang-switcher.css"],"names":[],"mappings":"AAAA;;yDAEyD;AACzD;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;AACF;;;AAGA;;EAEE,sDAAsD;AACxD;AACA,qCAAqC,iBAAiB,EAAE;AACxD,kCAAkC,iBAAiB,EAAE;AACrD,0BAA0B,iBAAiB,EAAE;AAC7C;6BAC6B,iBAAiB,EAAE;AAChD,sCAAsC,iBAAiB,EAAE","sourcesContent":["/* ════════════════════════════════════════════════════\n   Language Switcher — Dropdown\n   ════════════════════════════════════════════════════ */\n.lang-switcher {\n  position: relative;\n  display: inline-block;\n}\n\n.lang-switcher__trigger {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: 1.5px solid #d1d5db;\n  border-radius: 8px;\n  padding: 5px 10px 5px 12px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  color: #111;\n  letter-spacing: 0.03em;\n  transition: border-color 0.18s, background 0.18s;\n  white-space: nowrap;\n}\n\n.lang-switcher__trigger:hover {\n  border-color: #111;\n  background: #f5f5f5;\n}\n\n.lang-switcher__flag {\n  font-size: 16px;\n  line-height: 1;\n}\n\n.lang-switcher__label {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.lang-switcher__chevron {\n  width: 14px;\n  height: 14px;\n  color: #666;\n  transition: transform 0.2s;\n  flex-shrink: 0;\n}\n\n.lang-switcher--open .lang-switcher__chevron {\n  transform: rotate(180deg);\n}\n\n/* Dropdown panel */\n.lang-switcher__dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  background: #fff;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  min-width: 130px;\n  z-index: 999;\n  animation: dropdown-in 0.15s ease;\n}\n\n[dir=\"rtl\"] .lang-switcher__dropdown {\n  right: auto;\n  left: 0;\n}\n\n@keyframes dropdown-in {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.lang-switcher__option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 14px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  color: #333;\n  text-align: left;\n  transition: background 0.15s;\n}\n\n.lang-switcher__option:hover {\n  background: #f5f5f5;\n}\n\n.lang-switcher__option--active {\n  font-weight: 700;\n  color: #111;\n  background: #f9f9f9;\n}\n\n.lang-switcher__option--active::after {\n  content: \"✓\";\n  margin-left: auto;\n  font-size: 12px;\n  color: #111;\n}\n\n[dir=\"rtl\"] .lang-switcher__option {\n  text-align: right;\n  flex-direction: row-reverse;\n}\n\n[dir=\"rtl\"] .lang-switcher__option--active::after {\n  margin-left: 0;\n  margin-right: auto;\n}\n\n/* ── Mobile: group lang + hamburger together ── */\n.rassd-nav__right-mobile {\n  display: none;\n  align-items: center;\n  gap: 10px;\n}\n\n@media (max-width: 768px) {\n  .rassd-nav__links {\n    display: none !important;\n  }\n  .rassd-nav__right-mobile {\n    display: flex;\n  }\n}\n\n\n.rassd-root--ar,\n.rassd-root--ar * {\n  font-family: \"Segoe UI\", \"Tahoma\", \"Arial\", sans-serif;\n}\n[dir=\"rtl\"] .rassd-nav__mobile-link{ text-align: right; }\n[dir=\"rtl\"] .rassd-feature-card { text-align: right; }\n[dir=\"rtl\"] .form-group { text-align: right; }\n[dir=\"rtl\"] .form-input,\n[dir=\"rtl\"] .form-textarea { text-align: right; }\n[dir=\"rtl\"] .rassd-nav__mobile-menu { text-align: right; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
